<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between mb-1" style="height: 60px">
      <div>
        <div class="section-title">{{ $tc("banner", 2) }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("manageYourWebBannersHere") }}
        </div>
      </div>
      <div style="">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          @change="onChangePagination($event)"
          :per-page="perPage"
          aria-controls="my-table"
        />
      </div>
      <div>
        <b-button
          v-if="isEditable && $can('update', 'Banners')"
          variant="default"
          class="btn-blue"
          @click="() => updateBannerOrder()"
          >{{ $t("Save") }}</b-button
        >
        <b-button
          v-else-if="$can('update', 'Banners')"
          variant="default"
          class="btn-blue"
          @click="() => isBannerEditable()"
          >{{ $t("Edit order") }}</b-button
        >
        <b-button
          v-if="$can('create', 'Banners')"
          variant="default"
          :to="{ name: 'Add Banner' }"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
        <b-dropdown
          :text="filterButtonTitle"
          variant="dropdown-curve"
          class="ml-auto mr-3"
        >
          <b-dropdown-item
            v-for="(status, statusIndex) in statuses"
            :key="statusIndex"
            v-on:click="filterStatus(status.status)"
            >{{ status.status }}</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-2 mt-1">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center justify-content-between w-100">
        <div>
          <b-form-input
            @input="onSearch"
            v-model="searchValue"
            placeholder="Search..."
          />
        </div>
      </div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <table class="list-view-table">
      <thead>
        <tr>
          <th class="text-right" style="width: 50px">
            <span class="pr-4">{{ $tc("Status", 2) }}</span>
          </th>

          <th>{{ $t("type") }}</th>
          <th>
            <img
              v-if="this.columnName != 'banner_name'"
              @click="onSortValue('banner_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('banner_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('banner_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("name") }}
          </th>
          <th>
            <img
              v-if="this.columnName != 'from_date'"
              @click="onSortValue('from_date', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('from_date', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('from_date', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("From") }}
          </th>
          <th>
            <img
              v-if="this.columnName != 'to_date'"
              @click="onSortValue('to_date', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('to_date', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('to_date', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("to") }}
          </th>
          <th>{{ $tc("cinema", 2) }}</th>
        </tr>
      </thead>
      <template v-if="bannerlist && bannerlist.length > 0">
        <draggable
          :list="this.bannerlist"
          tag="tbody"
          @end="endSort($event)"
          :move="draggableElements"
        >
          <tr
            v-for="(item, key) in bannerlist"
            :key="key"
            class="light_grey_back"
          >
            <td>
              <div class="d-flex align-items-center">
                <span @click="onClickStatusDot(item)">
                  <StatusDot
                    :status="
                      item.banner_is_active == 'Y' ? 'active' : 'inactive'
                    "
                  />
                </span>
                <div
                  v-if="$can('update', 'Banners')"
                  class="edit-pen blue-icon ml-2 btn"
                  @click="goToRoute('Edit Banner', item)"
                ></div>
              </div>
            </td>

            <td>{{ item.banner_type ? item.banner_type : "-" }}</td>
            <td>{{ item.banner_name ? item.banner_name : "-" }}</td>
            <td>{{ item.from_date | dateparse }}</td>
            <td>{{ item.to_date | dateparse }}</td>
            <td class="cinema_col" v-b-tooltip.hover :title="item.cinemas">
              {{ item.cinemas ? item.cinemas : "-" }}
            </td>
          </tr>
        </draggable>
      </template>
      <tbody v-else>
        <td colspan="6">
          <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
          <NoRecords />
        </td>
      </tbody>
    </table>
    <br />
    <!-- <b-pagination
      v-model="currentPage"
      total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>-->

    <b-modal
      id="confirmation_active_inactive"
      title="Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="text-center pb-1 my-3">
        <p class="fs-16 mb-3">
          Are you sure you want to
          {{ selectedPop.banner_is_active == "Y" ? "Inactive" : "Active" }} this
          Signage Display?
        </p>
        <span class="mx-1"></span>
        <button
          v-if="selectedPop.banner_is_active == 'N'"
          class="btn btn-success btn-success-lg px-4 fs-14"
          @click.prevent.stop="UpdateStatus('Y')"
        >
          Active
        </button>
        <button
          v-else
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="UpdateStatus('N')"
        >
          Inactive
        </button>
        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmation_active_inactive')"
        >
          Cancel
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import draggable from "vuedraggable";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    draggable,
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      selectedPop: {
        unique_id: null,
        pp_type_id: null,
        pp_name: "",
        pp_lang_id: null,
        pp_rating_type: "",
        pp_banner: "",
        pp_title: "",
        pp_country_id: "",
        pp_image_url: "",
        pp_description: "",
        banner_is_active: "Y",
      },
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      bannerlist: [],
      cinema_id: null,
      searchValue: "",
      isSort: false,
      isAscending: true,
      orderby: "asc",
      columnName: "ms_banners.b_order",

      isEditable: false,
      filterButtonTitle: "Active",
      statuses: [
        { status: "Active" },
        { status: "Inactive" },
        { status: "All" },
      ],
      selectedStatus: "Active",
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  mounted() {
    this.cinema_id = this.secureStore.get("USINFO").cinema_id || null;
    this.getBannerList();
    this.getviewingnumber();
  },
  methods: {
    onClickStatusDot(item) {
      console.log("CLICKING onClickStatusDot", item);
      this.selectedPop = _.cloneDeep(item);
      this.$bvModal.show("confirmation_active_inactive");
    },

    UpdateStatus(status) {
      let loader = this.$loading.show();
      this.$bvModal.hide("confirmation_active_inactive");

      let payload = {
        unique_id: this.selectedPop["unique_id"],
        banner_is_active: status
          ? status
          : this.selectedPop["banner_is_active"] == "Y"
          ? "N"
          : "Y",
      };
      MasterService.UpdateBannerStatus(payload)
        .then((response) => {
          const { data } = response;

          console.log(data.message);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
          this.getBannerList();
        });
    },

    endSort(event) {
      this.bannerlist.map((x, index) => {
        if (this.currentPage != 1) {
          x.b_order = this.perPage * (this.currentPage - 1) + (index + 1);
        } else {
          x.b_order = index + 1;
        }
      });
      console.log("this.sorted banner", this.bannerlist);
      console.log("this.event", event);
    },
    filterStatus: function (status) {
      this.filterButtonTitle = status;
      this.selectedStatus = status;
      this.getBannerList();
    },
    isBannerEditable: function () {
      this.isEditable = true;
      let active_rating = [];
      if (this.isEditable) {
        this.filterButtonTitle = "Active";
        this.selectedStatus = "Active";
        this.onDropDownChangeValue("All");
        this.$forceUpdate();
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    onChangePagination(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getBannerList();
      } else {
        this.currentPage = event;
        this.getBannerList();
      }
    },
    onSearch(event) {
      this.searchValue = event;
      this.getBannerList();
    },
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getBannerList();
    },
    getBannerList() {
      MasterService.GetMasterBanners({
        limit: this.perPage,
        currentPage: this.currentPage,
        cinema_id: this.cinema_id,
        search: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderby,
        status: this.selectedStatus,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.bannerlist = data.Records;
            this.bannerlistCopy = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.bannerlist = [];
            this.bannerlistCopy = [];
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    updateBannerOrder: function () {
      this.isEditable = false;
      let payload = {
        Banners: this.bannerlist,
      };
      console.log("In update section", this.bannerlist);
      MasterService.UpdateBannerOrder(payload)
        .then((data) => {
          console.log("data", data);
          if (data && data.status) {
            this.onDropDownChangeValue("10");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goToRoute: function (name, banner) {
      this.$router.push({
        name: name,
        params: {
          b_id: banner.unique_id,
        },
      });
    },
    draggableElements: function () {
      return this.isEditable;
    },
  },
};
</script>
<style>
.cinema_col {
  display: inline-block;
  width: 180px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/BannerComponents/banners.vue